import request from '@/axios/index.js'
const center = '/user/gold/';
const goldPay = '/user/goldPay/'
const gldPay = '/user/gldPay/'


export function applyGoldApi(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'applyGold'
  })
}
export function doConfirmGoldApi(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'doConfirmGold'
  })
}
export function findGoldEstbOrRcPtyOrPypt(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'findGoldEstbOrRcPtyOrPypt'
  })
}
export function queryGoldPageApi(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'queryGoldPage'
  })
}
export function queryTransRecord(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'queryTransRecord'
  })
}


export function verifyTradePassword(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: goldPay + 'verifyTradePassword'
  })
}

export function getDetailApi(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'getDetail'
  })
}
export function getLawForDetail(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'getLawForDetail'
  })
}
export function queryPayRecord(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'queryPayRecord'
  })
}
export function queryDocumInformation(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'queryDocumInformation'
  })
}

export function pagingCircleList(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: gldPay + 'pagingCircleList'
  })
}
export function payApi(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: gldPay + 'pay'
  })
}
// 查看转让协议
export function queryGoldTransferContract(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: goldPay + 'queryGoldTransferContract'
  })
}
// 祺信签发-查看未签署的付款承若函
export function getLetterofCommitment(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: '/user/gold/getLetterofCommitment'
  })
}
// 祺信支付撤销
export function goldPayWithdraw(data, loading) {
  return request.axios({
    loading: loading,
    type: "post",
    url: `/user/goldPay/withdraw`,
    data: data
  })
}
// 祺信开立待签收撤销
export function goldbuyerWithdraw(data, loading) {
  return request.axios({
    loading: loading,
    type: "post",
    url: `/user/goldbuyer/withdraw`,
    data: data
  })
}
// 祺信变更
export function GoldenbillBuyerModifiedAPI(data, loading) {
  return request.axios({
    loading: loading,
    type: "post",
    url: `/user/goldbuyer/modified`,
    data: data
  })
}
// 查询1年期LPR
export function getParamByKey(data, loading) {
  return request.axios({
    loading: loading,
    type: "post",
    url: `/systemParam/getParamByKey`,
    data: data
  })
}
// 祺信记录导出
export function queryGoldPageExport(data, loading) {
  return request.axios({
    loading: loading,
    type: "post",
    url: `/user/gold/queryGoldPageExport`,
    data: data,
    success: true,
    responseType: "blob"
  })
}
// 追溯记录导出
export function goldPayRecordExport(data, loading) {
  return request.axios({
    loading: loading,
    type: "post",
    url: `/user/gold/goldPayRecordExport`,
    data: data,
    success: true,
    responseType: "blob"
  })
}

// 区块信息查询
export function getGldBlockInfo(gldId, loading) {
  return request.axios({
    loading: loading,
    type: "get",
    url: `/getGldBlockInfo/${gldId}`,
  })
}

// 票面左下角二维码
export function getBlockchainPicture(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    type: "get",
    url: `/user/gold/getBlockchainPicture`,
  })
}

export function existOnTheWay(data, loading) {
  return request.axios({
    loading: loading,
    type: "get",
    url: `/user/goldbuyer/existOnTheWay?gldId=${data}`,
  })
}

//兑付异常列表查询
export function queryGoldPayFailApi(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'queryGoldPayFailPage'
  })
}
//兑付异常列表付款额总计查询
export function queryGoldPayFailCount(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'queryGoldCount'
  })
}
//兑付
export function paymentFailGld(data,loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: center + 'paymentFailGld'
  })
}
//兑付
export function getGoldenTicketApproveList(data, loading) {
  return request.axios({
    loading: loading,
    data: data,
    url: '/user/goldbuyer/getGoldenTicketApproveList'
  })
}



// WEBPACK FOOTER //
// ./src/api/gold.js